import { cloneDeep } from 'lodash';
import React, { useEffect, useState } from 'react';
import { passwordVerifecator } from '../../utils/Validation';
import { NewPasswordPopperItem } from './NewPasswordPopperItem';

const passwordRulesConfig = [
    {
        text: "מינימום 8 תווים, מקסימום 20 תווים",
        index: 0
    },
    {
        text: "אנגלית בלבד",
        index: 1
    },
    {
        text: "לפחות אות גדולה אחת",
        index: 2
    },
    {
        text: "לפחות אות קטנה אחת",
        index: 3
    },
    {
        text: "לפחות מספר אחד",
        index: 4
    },
    {
        text: "לא ניתן להשתמש בסיסמה הישנה שנית",
        index: 5
    },
    {
        text: "סיסמה לא יכולה להכיל את אותו התו 3 פעמים ברציפות",
        index: 6
    }
]

export const NewPasswordPopper = ({
    setPassError,
    password,
    isOpen,
    triggerd
}) => {
    const [rulesUI, setRulesUI] = useState([]);

    useEffect(() => {
        const UIRules = passwordVerifecator(password, passwordRulesConfig);
        setRulesUI(UIRules);
    }, [password]);

    useEffect(() => {
        const clonedCheck = cloneDeep(rulesUI);
        clonedCheck.splice(-1);
        if (rulesUI.every((el) => el.isActive)) {
            setPassError(false);
        } else if (triggerd) {
            setPassError(true);
        }
    }, [rulesUI, setPassError, triggerd]);

    return (
        isOpen ?
            <div class={"passwordPopper"}>
                {rulesUI.map((passwordRule, index) => {
                    return <NewPasswordPopperItem key={index} item={passwordRule} />;
                })}
            </div> : null
    );
};